var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLedger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0933 3.46631H11.4828V16.4313H24.4652V6.82083C24.4652 4.98238 22.9491 3.46631 21.1107 3.46631C21.102 3.46631 21.0933 3.46631 21.0933 3.46631Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.48558 3.46631H6.8301C4.99165 3.46631 3.47559 4.98238 3.47559 6.82083V8.4763H8.48558V3.46631Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4668 11.4734H8.47679V16.4834H3.4668V11.4734Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4901 24.4557H21.1456C22.984 24.4557 24.5001 22.9396 24.5001 21.1012V21.0925V19.4893H19.4901V24.4557Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4828 19.4805H16.4928V24.4905H11.4828V19.4805Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.4668 19.4805V21.1359C3.4668 22.9744 4.98286 24.4905 6.82131 24.4905H8.47679V19.4805H3.4668Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLedger);
export default __webpack_public_path__ + "static/media/ledger.8422b89a47dddaae8d48c655adcc929a.svg";
export { ForwardRef as ReactComponent };